import React from 'react';
import { SelectItem } from '../ui/enhanced-select';

interface CustomSelectItemProps extends React.ComponentPropsWithoutRef<typeof SelectItem> {
  onItemClick?: (value: string) => void;
}

export const CustomSelectItem = React.forwardRef<
  React.ElementRef<typeof SelectItem>,
  CustomSelectItemProps
>(({ onItemClick, value, children, ...props }, ref) => {
  return (
    <SelectItem 
      ref={ref} 
      value={value} 
      {...props}
    >
      {children}
    </SelectItem>
  );
});

CustomSelectItem.displayName = 'CustomSelectItem';
